export enum GlobalBookingTravelClass {
  ECONOMY = 'ECONOMY',
  ECOPREMIUM = 'ECOPREMIUM',
  BUSINESS = 'BUSINESS',
  FIRST = 'FIRST',
  MIXED = 'MIXED',
}

export type GlobalBookingTravelClassValue = keyof typeof GlobalBookingTravelClass;

export type GlobalBookingTravelClassDataMap = {
  [k in GlobalBookingTravelClassValue]: {
    icon: string;
    translationKey: string;
  };
};

export const COMMON_BOOKING_TRAVEL_CLASSES: GlobalBookingTravelClassDataMap = {
  FIRST: {
    translationKey: 'travelClass.first',
    icon: 'business-class',
  },
  BUSINESS: {
    translationKey: 'travelClass.business',
    icon: 'business-class',
  },
  ECONOMY: {
    translationKey: 'travelClass.economy',
    icon: 'seat-or-economy',
  },
  ECOPREMIUM: {
    translationKey: 'travelClass.ecopremium',
    icon: 'seat-or-economy',
  },
  MIXED: {
    translationKey: 'travelClass.mixed',
    icon: 'seat-or-economy',
  },
};
